import React, { Component } from 'react';
import translations from '../../translations';
import withTranslations from '../../utils/translations/withTranslations';
import classNames from '../../utils/classNames';

import './Language.css';

class Language extends Component {
  setActive(language) {
    translations.setLanguage(language);
  }

  render() {
    const { className } = this.props;
    
    return (
      <div className={className}>
        <span
          onClick={() => this.setActive('nl')}
          className={classNames(
            'Language__Item',
            translations.active === 'nl' && 'Language__Item--active'
          )}
        >
          Nederlands
        </span>
        <span> - </span>
        <span
          onClick={() => this.setActive('fr')}
          className={classNames(
            'Language__Item',
            translations.active === 'fr' && 'Language__Item--active'
          )}
        >
          Français
        </span>
      </div>
    );
  }
}

export default withTranslations(Language);
